webix.protoUI({
	name: "ssheet-separator",
	defaults:{
		css: "webix_ssheet_toolbar_spacer",
		template: " ",
		width: 1,
		borderless: true
	}
},webix.ui.view);